"use strict";

exports.__esModule = true;
exports.getYTickFormatter = void 0;
var _d3Format = require("d3-format");
var getYTickFormatter = exports.getYTickFormatter = function getYTickFormatter(units, value) {
  var SI = (0, _d3Format.format)(".2s");
  return value >= 100000 ? value % 1 === 0 ? SI(value).replace(".0", "") : SI(value) : value;
};